/* eslint react/no-find-dom-node: 0 */
/* globals certona */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import resxclsx from './resxclsx';
import { RecsContext } from './RecsContext';
import './recommendations.style.scss';

const dynamicRecSchemeList = [
  'categorylevel2horizontal1_rr',
  'visuallysimilar_1_0',
  'PLP_Browse',
  'PLP_Browse_In_Stock',
  'PLP_Search_In_Stock',
  'PLP_Browse_Mobile',
  'pip_mobile',
  'pip_sem_mobile',
  'pipsem',
  'pipinstock',
  'pip_instock_mobile',
  'searchViewed',
  'required_items',
  'articles_rec',
];

class RecsContextProvider extends Component {

  state = {
    resx: {},
    ready: this.props.ready//eslint-disable-line
  };

  dynamicSchemeList = new Set();

  recommendationSchemeList = new Set();

  deferredSchemeList = new Set();

  async componentDidMount() {
    await this.loadDependencies();
    const { ready } = this.state;
    if (typeof ready !== 'boolean') {
      this.setState({ ready: true }, () => this.loadRecs());//eslint-disable-line
    } else if (ready) {
      this.loadRecs();
    }
    this.setupDeferredRecs();
  }

  componentDidUpdate(prevProps) {
    const { ready: readyState } = this.state;
    const { ready: readyProp, resx } = this.props;
    const readyUpdated = typeof readyProp !== 'undefined' && readyProp !== readyState;
    const productsUpdated = resx && prevProps.resx
    && resx.products !== prevProps.resx.products;
    if (readyUpdated || productsUpdated) {
      this.setState({ ready: true }, () => this.loadRecs());//eslint-disable-line
    }
  }

  componentWillUnmount() {
    this.dynamicSchemeList.clear();
    this.recommendationSchemeList.clear();
    this.deferredSchemeList.clear();
  }

  setupDeferredRecs = () => {
    if (window && this.deferredSchemeList.size > 0) {
      window.addEventListener('scroll', this.executeDeferredRecs);
    }
  }

  executeDeferredRecs = () => {
    window.removeEventListener('scroll', this.executeDeferredRecs);

    this.deferredSchemeList.forEach((scheme, i) => {
      this.addSchema(scheme);
    });
    window.resx = this.getResx({ deferred: true });
    this.certona.refresh(window.resx);
  }

  getResx = (schemaOptions) => {
    const { deferred = false } = schemaOptions || {};
    const resx = {
      ...this.props.resx,//eslint-disable-line
      ...this.state.resx//eslint-disable-line
    };

    resx.dynamicRecsSchema = deferred ? [] : Array.from(this.dynamicSchemeList);
    resx.certonaSchema = deferred ? Array.from(this.deferredSchemeList) : Array.from(this.recommendationSchemeList);
    return resx;
  };

  loadDependencies = async () => {

    if (this.certona) {
      return Promise.resolve();
    }

    const certonaPromise = import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "thd-recommendations-all" */
      'thd-recommendations-all/dist/all.min'
    );
    const [certona] = await Promise.all([certonaPromise]);
    this.certona = certona;

    if (typeof window !== 'undefined') {
      window.THD_GLOBAL = window.THD_GLOBAL || {};
      window.THD_GLOBAL.secureHostName = window.THD_GLOBAL.secureHostName || 'www.homedepot.com';
      window.THD_GLOBAL.nonSecureHostName = window.THD_GLOBAL.nonSecureHostName || 'www.homedepot.com';
    }
    return Promise.resolve();
  };

  loadRecs = () => {

    // this causes a 2-3 second delay on route change
    // something to do with recs calling a bunch
    // of methods that initializeCookieManager
    // that shoul be a singleton however, the all.min
    // is bundling an older version of cookie-utils that
    // is not a singleton

    const { ready } = this.state;

    if (!ready) {
      return;
    }

    if (this.to && typeof window !== 'undefined') {
      clearTimeout(this.to);
    }
    this.to = setTimeout(() => {
      window.resx = this.getResx();

      const trackingId = window.cookieUtils.readBrowserCookie('RES_TRACKINGID');
      if (!trackingId && resxclsx) {
        resxclsx.run();
      }
      this.certona.refresh(window.resx);
    }, 1000);

  };

  addSchema = (schema, defer) => {
    const { ready } = this.state;
    // if (!ready) return;
    if (!defer) {
      if (dynamicRecSchemeList.indexOf(schema) !== -1) {
        this.dynamicSchemeList.add(schema);
      } else {
        this.recommendationSchemeList.add(schema);
      }
    } else {
      this.deferredSchemeList.add(schema);
    }
  };

  updateResx = (resx) => {
    this.setState((state) => ({
      ...state,
      resx
    }));
  };

  render() {

    const { children } = this.props;
    const context = {
      addSchema: this.addSchema,
      updateResx: this.updateResx
    };

    return (
      <RecsContext.Provider value={context}>
        {children}
      </RecsContext.Provider>
    );
  }
}

RecsContextProvider.displayName = 'RecsContextProvider';

RecsContextProvider.propTypes = {
  children: PropTypes.node,
  resx: PropTypes.shape({ products: PropTypes.string }),
  ready: PropTypes.bool
};

RecsContextProvider.defaultProps = {
  children: null,
  resx: { products: '' },
  ready: undefined
};

export default RecsContextProvider;
